export default __webpack_public_path__ + "static/media/landing.920907da.jpg";